module.exports = __webpack_public_path__ + "img/round-blue.33624e2a.svg";